<template>
    <div class="px-3 border-b border-b-indigo-600" :class="selected ? 'bg-blue-400 rounded-lg' : 'hover:bg-blue-400 hover:rounded-lg'">
      <Link class="flex items-center py-4 w-full text-xs" v-bind:href="link" v-bind:method="method" v-bind:as="as">
        <font-awesome-icon v-bind:icon="icon" class="mr-3 w-4 h-4" />
        <span class="whitespace-nowrap overflow-hidden">{{ label }}</span>
      </Link>
    </div>
</template>
<script>
import { objectExpression } from '@babel/types'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    icon: String,
    link: String,
    label: String,
    selected: Boolean,
    method: String,
    as: String,
  },
}
</script>